// Environment configuration
export const env = {
  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || (import.meta.env.DEV ? '/api' : 'https://api.uu.me'),
  
  // App Configuration
  APP_NAME: import.meta.env.VITE_APP_NAME || 'uumail',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  
  // Environment
  NODE_ENV: import.meta.env.MODE,
  DEV: import.meta.env.MODE === 'development',
  PROD: import.meta.env.PROD,
} as const;

if (!env.API_BASE_URL) {
  console.warn('VITE_API_BASE_URL is not set, using default');
}

export default env;
